import { render } from "./AreaScreenDonutTable.vue?vue&type=template&id=b5562aa6&scoped=true"
import script from "./AreaScreenDonutTable.vue?vue&type=script&lang=js"
export * from "./AreaScreenDonutTable.vue?vue&type=script&lang=js"

import "./AreaScreenDonutTable.vue?vue&type=style&index=0&id=b5562aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5562aa6"]])

export default __exports__